import apiClient from './axios-instance';
import { ApiResponse, ApiError } from './types';
import { isDebugModeActive } from './axios-instance';

// Función para verificar si el modo debug está activo
export const checkDebugMode = (): boolean => {
  return isDebugModeActive();
};
// return response as T;
export const apiGet = async <T>(url: string, params?: object): Promise<T> => {
  try {
    const response = await apiClient.get<ApiResponse<T>>(url, { params });
    return response as T;
  } catch (error) {
    throw error as ApiError;
  }
};

export const apiPost = async <T>(url: string, data?: unknown): Promise<T> => {
  try {
    const response = await apiClient.post<ApiResponse<T>>(url, data);
    return response as T;
  } catch (error) {
    throw error as ApiError;
  }
};

export const apiPut = async <T>(url: string, data?: unknown): Promise<T> => {
  try {
    const response = await apiClient.put<ApiResponse<T>>(url, data);
    return response as T;
  } catch (error) {
    throw error as ApiError;
  }
};

export const apiDelete = async <T>(url: string): Promise<T> => {
  try {
    const response = await apiClient.delete<ApiResponse<T>>(url);
    return response as T;
  } catch (error) {
    throw error as ApiError;
  }
};
